import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/rawan/Header";
import { Footer } from "@/components/rawan/Footer";
import { EditableStaticPage } from "@/components/rawan/EditableStaticPage";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "سياسة ملفات تعريف الارتباط — Rawan UI" },
      { name: "description", content: "سياسة ملفات تعريف الارتباط (Cookies Policy) الخاصة بموقع Rawan UI." },
    ],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 max-w-3xl">
        <EditableStaticPage
          pageKey="cookies"
          titleAr="سياسة ملفات تعريف الارتباط"
          titleEn="Cookie Policy"
          titleFr="Politique des cookies"
          defaultParagraphsAr={[
            "## ما الذي نخزنه\n\nنستخدم ملفات تعريف الارتباط لتخزين **تفضيلاتك الشخصية** مثل الوضع الداكن/الفاتح، ولغة الواجهة، وحالة تسجيل الدخول.",
            "## لماذا\n\n- لفهم كيفية تفاعل الزوار مع الموقع.\n- لتحسين السرعة وتجربة الاستخدام.\n- لتخصيص المحتوى ليلائم احتياجاتك.",
            "## التحكم\n\nيمكنك في أي وقت **التحكم** في إعدادات ملفات تعريف الارتباط أو مسحها من خلال إعدادات المتصفح الخاص بك.",
          ]}
          defaultParagraphsEn={[
            "## What we store\n\nWe use cookies to store **your preferences** — theme (dark/light), language, and authentication state.",
            "## Why\n\n- To understand how visitors interact with the site.\n- To improve performance and UX.\n- To tailor the interface to you.",
            "## Control\n\nYou can **control or delete** cookies at any time directly through your browser settings.",
          ]}
          defaultParagraphsFr={[
            "## Ce que nous stockons\n\nNous utilisons des cookies pour conserver **vos préférences** : thème (sombre/clair), langue et état d'authentification.",
            "## Pourquoi\n\n- Comprendre comment les visiteurs utilisent le site.\n- Améliorer les performances et l'UX.\n- Adapter l'interface à vos besoins.",
            "## Contrôle\n\nVous pouvez à tout moment **contrôler ou supprimer** les cookies via les paramètres de votre navigateur.",
          ]}
        />
      </main>
      <Footer />
    </div>
  );
}
